package com.pincer.app.viewmodel

import com.pincer.app.ApplicationState
import com.pincer.app.I18n
import com.pincer.core.functions.readable
import com.pincer.core.functions.validateEmail
import com.pincer.core.functions.validateCode
import com.pincer.core.functions.validateCredential
import com.pincer.core.functions.validatePrincipalName

fun missingCredentials(state: ApplicationState, context: Node) {
    if (!state.personalIsReady()) return
    if (state.personalSelf()!!.name.isNullOrBlank()) {
        context.node(key = "yourName", prominence = Prominence.Primary) {
            val textInBox = state.personalUiSelf()!!.name ?: state.personalSelf()!!.name
            val problem = validatePrincipalName(textInBox)
            input(key = "setPersonalName", action = Action.SetPersonalName, wording = textInBox ?: "", problem = problem)
            possibleProblem(problem)
        }
    }
    if (state.personalPincer()!!.name.isNullOrBlank()) {
        if (state.transient.expectingCode) {
            context.node(key = "credentialCode", prominence = Prominence.Primary) {
                node(key = "message", wording = I18n.translate("credentialCodeHelpText", state.transient.claimedCredential!!))
                val problem = validateCode(state.transient.credentialCode)
                input(key = "principalConfirmCode", action = Action.PrincipalConfirmCode, wording = state.transient.credentialCode ?: "", problem = problem)
                possibleProblem(problem)
                helpText("sixDigitCode")
            }
        }
        else {
            context.node("emailOrPhone") {
                val textInBox = state.transient.claimedCredential ?: state.personalPincer()!!.name
                val problem = validateCredential(textInBox)
                input(key = "principalTriggerCode", action = Action.PrincipalTriggerCode, wording = textInBox ?: "", problem = problem)
                possibleProblem(problem)
                helpText("credentialHelpText")
            }
        }
    }
}